import * as React from 'react';

import type { AnimationCallbacks, AnimationPhases } from './animation';

/*
 * Internal context used between AnimateLifecycle and useAnimateLifecycle.
 */

export interface AnimateInternalManager {
    bindAnimations: (
        ref: React.Ref<HTMLElement>,
        phases: AnimationPhases,
        callbacks: AnimationCallbacks
    ) => React.Ref<HTMLElement>;
}

export const AnimateInternalManagerContext = React.createContext<AnimateInternalManager>({
    bindAnimations: (ref, _phases, _callbacks) => {
        return ref;
    },
});
